var map = {
	"./action.png": "c7d2",
	"./adventure.png": "22c0",
	"./animation.png": "d64a",
	"./biography.png": "eeca",
	"./comedy.png": "cf6b",
	"./crime.png": "a911",
	"./documentary.png": "caa6",
	"./drama.png": "b9fa",
	"./family.png": "b96f",
	"./fantasy.png": "f4eb",
	"./foreign.png": "65c2",
	"./history.png": "1c5f",
	"./horror.png": "e86b",
	"./iranian.png": "ab24",
	"./logo.png": "4ffd",
	"./musical.png": "1cd4",
	"./mystery.png": "e412",
	"./romance.png": "4e02",
	"./sci_fi.png": "b7a7",
	"./series.png": "e31c",
	"./sport.png": "c88d",
	"./thriller.png": "141e",
	"./war.png": "d472"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";